(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './Pagination'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Pagination'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Pagination);
    global.index = mod.exports;
  }
})(this, function (exports, _Pagination) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Pagination = undefined;

  var _Pagination2 = _interopRequireDefault(_Pagination);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.Pagination = _Pagination2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Pagination/index.js
// module id = 858
// module chunks = 1